import host from "../host";

const imgLoc = `${host}images/`;

export default imgLoc;
